module.exports = __webpack_public_path__ + "2e5329ec6c94f776472abde5121a7c13.svg";